import {SYSTEM_COLUMN_PREFIX} from 'data-frames/DataFrameConstants';
import {DataFrameColumnDef} from 'data-frames/DataFrameTypes';

export default function isSystemColumn(column: DataFrameColumnDef): boolean {
  return column.systemName.startsWith(SYSTEM_COLUMN_PREFIX);
}
